

import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import AuditLogs from "./AuditLogs";
import LoginIssues from "./LoginIssues";
import "./AdminSettings.css";
// import EmailSettings from "./EmailSettings";
// import ApiKeys from "./ApiKeys";

const AdminSetting = () => {
  const [activeCard, setActiveCard] = useState("audit");

  const [searchParams] = useSearchParams();


   useEffect(() => {

      const tab =
         searchParams.get("tab");

      if (
         tab === "login-issues"
      ) {

         setActiveCard(
            "login-issues"
         );

      }

      if (tab === "audit") {

         setActiveCard(
            "audit"
         );

      }

   }, [searchParams]);

  const renderContent = () => {
    switch (activeCard) {
      case "audit":
        return <AuditLogs />;
      case "login-issues":
        return <LoginIssues />;
      case "apikey":
        return <div>API Key Settings Coming Soon</div>;
      default:
        return <div className="placeholder">Select a setting</div>;
    }
  };

  return (
    <div className="settings-container">
      
      {/* Cards Section */}
      <div className="settings-cards">
        <div className={`card ${activeCard === "audit" ? "active" : ""}`} onClick={() => setActiveCard("audit")}>
          <h3>Audit Logs</h3>
          <p>Track admin actions & system activity</p>
        </div>

        <div className={`card ${activeCard === "login-issues" ? "active" : ""}`} onClick={() => setActiveCard("login-issues")}>
          <h3>Login Issues</h3>
          <p>View and manage login issues</p>
        </div>

        <div className={`card ${activeCard === "apikey" ? "active" : ""}`} onClick={() => setActiveCard("apikey")}>
          <h3>API Keys</h3>
          <p>Generate & manage API keys</p>
        </div>
      </div>

      {/* Dynamic Content */}
      <div className="settings-content-audit">
        {renderContent()}
      </div>

    </div>
  );
};

export default AdminSetting;